import { connect } from "react-redux";
import React, { useEffect, useState } from 'react';
import { withRouter, useHistory, useLocation } from 'react-router-dom';
import * as logger from '../../../../logger';
import {
    DialogTitle,
    Paper,
    Grid,
    Button,
    ExpansionPanelDetails,
    Dialog,
    DialogContent,
    DialogActions,
    IconButton,
    InputAdornment,
    Card,
    CardContent,
    Typography,
} from '@material-ui/core';
import { maintenanceBookCss as useStyles } from '../VehicleCss';
import RightSideBar from '../../../components/RightSideBar/RightSideBar';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import DeleteExpenseDialog from '../../../components/VehicleDialogs/DeleteExpenseDialog';
import { PandL, Expenses, FetchExpenseDetails, fetchMaintenanceBook, fetchMaintenanceUpcoming, singleTruck, getVehicleMaintenanceConfig } from '../../../../store/actions/vehicleActionCreator';
import { numberFormat, getDateInStringDocumentDDMMMYYYY, getVehicleNumberValuesDWeb, numberFormatComma, getTripDateFilterValues, getDateStringDDMMM } from '../../../../utils/utils';
import { MaintenanceIcon } from '../../../../components/icons';
import DateFilter from "../../../components/FilterComponent/DateFilter";
import CustomDateFilterDialog from '../../../components/FilterComponent/CustomDateFilter';
import ExpenseTypeFilter from '../../../components/FilterComponent/ExpenseTypeFilter';
import AddMaintainanceExpenseDialog from '../../../components/VehicleDialogs/AddMaintainanceExpenseDialog';
import MarkDoneDialog from '../../../components/VehicleDialogs/SettleAmountDialog';
import DoneIcon from '@material-ui/icons/Done';
import { trackDwebEvent } from '../../../analytics';

const MaintenanceBook = ({ open, onClose, vehicle, dispatchGetMaintenanceConfig, dispatchGetSingleTruck, dispatchFetchUpcoming, dispatchGetMaintenanceBook, dispatchFetchSingleExpense, dispatchGetTripExpenses, dispatchGetPandL }) => {

    let submit, formValues;

    const [maintenanceBookDetails, setMaintenanceBookDetails] = useState({});
    const [vehicleNumberType, setVehicleNumberType] = useState({ vehicleNumberPrefix: "", vehicleNumberSuffix: "" })
    const [onOpen, setOnOpen] = useState(null);
    const [dateFilterValue, setDateFilterValue] = useState("ALL_MONTHS");
    const [changeFlag, setChangeFlag] = useState(false);
    const [singleExpenseDetails, setSingleExpenseDetails] = useState({});
    const [editExpenseDialog, setEditExpenseDialog] = useState(false);
    const [addMaintenanceExpenseDialogOpen, setAddMaintenanceExpenseDialogOpen] = useState(false);
    const [expenseIdValue, setExpenseIdValue] = useState("");
    const [deleteExpenseDialogOpen, setDeleteExpenseDialogOpen] = useState(false);
    const [expenseFilterValue, setExpenseFilterValue] = useState("All_Expense");
    const [maintenanceUpcoming, setMaintenanceUpcoming] = useState([]);
    const [markPaidDialogOpen, setMarkPaidDialogOpen] = useState(false);
    const [upcomingValue, setUpcomingValue] = useState({});
    const [customFilter, setCustomFilter] = useState(false);
    const [customFilterValue, setCustomFilterValue] = useState({});

    const classes = useStyles();

    let location = useLocation();
    let path = location && location.pathname ? location.pathname.split("/") : [];
    let vehicleId = path && path[path.length - 1] ? path[path.length - 1] : "";

    var dateFilterValueUtil = getTripDateFilterValues();

    useEffect(() => {

        let startDateRange = dateFilterValueUtil[dateFilterValue].startDateRange;

        let maintenanceData = {
            vehicleId: Number(vehicleId),
            startDateRange: {
                startTimeEpoch: startDateRange.startTimeEpoch,
                endTimeEpoch: startDateRange.endTimeEpoch
            },
            expenseType: []
        }


        dispatchGetMaintenanceBook(maintenanceData, null,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Maintenance Book Dweb", "Get maintenance book successfull");
                    setOnOpen(true);
                    dispatchFetchUpcoming(maintenanceData,
                        (data) => {
                            if (data && data.status && data.status.code == 200) {
                                logger.log("Maintenance Book Dweb", "Fetch maintenance upcoming successfull");
                            }
                        },
                        () => {
                            logger.log("Maintenance Book Dweb", "Fetch maintenance upcoming failed");
                        }
                    );
                }
            },
            () => {
                logger.log("Maintenance Book Dweb", "Get maintenance book failed")
            }
        );
    }, [open]);

    useEffect(() => {
        if (vehicle.truckBooks) {
            setMaintenanceBookDetails(vehicle.truckBooks);
            const vehicleNumberArray = getVehicleNumberValuesDWeb(vehicle.truckBooks.vehicleNumber);
            if (vehicleNumberArray && vehicleNumberArray.length > 0) {
                const vehicleNumberSuffixValue = vehicleNumberArray.pop();
                const vehicleNumberPrefixValue = vehicleNumberArray.join("");

                setVehicleNumberType({
                    vehicleNumberPrefix: vehicleNumberPrefixValue,
                    vehicleNumberSuffix: vehicleNumberSuffixValue,
                })
            }
        }

        if (vehicle.singleExpenseDetails) {
            setSingleExpenseDetails(vehicle.singleExpenseDetails)
        }

        if (vehicle.maintenanceUpcoming) {
            setMaintenanceUpcoming(vehicle.maintenanceUpcoming);
        }
    }, [vehicle.truckBooks, vehicle.singleExpenseDetails, vehicle.maintenanceUpcoming]);

    useEffect(() => {

        if (changeFlag) {
            let startDateRange = dateFilterValueUtil[dateFilterValue].startDateRange;

            let maintenanceData = {
                vehicleId: Number(vehicleId),
                startDateRange: {
                    startTimeEpoch: startDateRange.startTimeEpoch,
                    endTimeEpoch: startDateRange.endTimeEpoch
                },
            }

            if (expenseFilterValue == "All_Expense") {
                maintenanceData.expenseType = []
            } else {
                maintenanceData.expenseType = [expenseFilterValue]
            }

            if (customFilterValue && customFilterValue.startTimeEpoch) {
                maintenanceData.startDateRange = customFilterValue;
            }

            dispatchGetMaintenanceBook(maintenanceData, null,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log("Maintenance Book Dweb", "Get maintenance book successfull");
                        dispatchFetchUpcoming(maintenanceData,
                            (data) => {
                                if (data && data.status && data.status.code == 200) {
                                    logger.log("Maintenance Book Dweb", "Fetch maintenance upcoming successfull");
                                }
                            },
                            () => {
                                logger.log("Maintenance Book Dweb", "Fetch maintenance upcoming failed");
                            }
                        );
                    }
                },
                () => {
                    logger.log("Maintenance Book Dweb", "Get maintenance book failed")
                }
            );
        }
    }, [dateFilterValue, expenseFilterValue, customFilterValue]);

    useEffect(() => {

        if (maintenanceBookDetails && maintenanceBookDetails.vehicleId) {
            trackDwebEvent("Dweb SVP Fuel Book ", {
                vehicle_id: vehicleId,
                vehicle_number: maintenanceBookDetails && maintenanceBookDetails.vehicleNumber ? maintenanceBookDetails.vehicleNumber : "",
                total_maintenance_expense: maintenanceBookDetails && maintenanceBookDetails.totalCost ? maintenanceBookDetails.totalCost : ""
            });
        }

    }, [maintenanceBookDetails])

    const handleDateValue = (value) => {
        if (value == "CUSTOM") {
            setCustomFilter(true);
        }
        else {
            setDateFilterValue(value);
            setCustomFilter(false);
            setCustomFilterValue({});
        }
        setChangeFlag(true);
    }

    const onConfirm = () => {
        setOnOpen(false);
        onClose();
    }

    const handleAddMaintenanceExpense = () => {
        trackDwebEvent("Dweb SVP Maintenance Book Expense Initiated", {
            vehicle_id: vehicleId,
            vehicle_number: maintenanceBookDetails && maintenanceBookDetails.vehicleNumber ? maintenanceBookDetails.vehicleNumber : "",
            total_maintenance_expense: maintenanceBookDetails && maintenanceBookDetails.totalCost ? maintenanceBookDetails.totalCost : ""
        });
        setSingleExpenseDetails({});
        setAddMaintenanceExpenseDialogOpen(true);

    }

    const handleEditExpense = (expenseId) => {
        setEditExpenseDialog(true);
        setExpenseIdValue(expenseId);
        dispatchFetchSingleExpense(expenseId,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Maintenance Book Dweb", "Get single expense details successfull");
                    setAddMaintenanceExpenseDialogOpen(true);
                }
            },
            () => {
                logger.log("Maintenance Book Dweb", "Get single expense details failed");
            }
        );
    }

    const handleDeleteExpense = (expenseId) => {
        setExpenseIdValue(expenseId);
        setDeleteExpenseDialogOpen(true);
    }

    const handleDeleteClose = () => {
        setDeleteExpenseDialogOpen(false);
    }

    const handleDeleteExpenseConfirm = () => {
        setDeleteExpenseDialogOpen(false);
        recall();
    }

    const handleAddMaintenanceExpenseClose = () => {
        setAddMaintenanceExpenseDialogOpen(false);
        setEditExpenseDialog(false);
        setSingleExpenseDetails({});
    }

    const handleExpenseConfirm = () => {
        setAddMaintenanceExpenseDialogOpen(false);
        setEditExpenseDialog(false);
        setSingleExpenseDetails({});
        recall();
    }

    const recall = () => {

        var startDateRange = dateFilterValueUtil["ALL_MONTHS"].startDateRange;

        var PandLdata = {
            vehicleId: Number(vehicleId),
            startDateRange: {
                startTimeEpoch: startDateRange.startTimeEpoch,
                endTimeEpoch: startDateRange.endTimeEpoch
            }
        };

        var expenseData = {
            vehicleId: Number(vehicleId),
            startDateRange: {
                startTimeEpoch: startDateRange.startTimeEpoch,
                endTimeEpoch: startDateRange.endTimeEpoch
            },
            expenseParentType: []
        };

        let maintenanceData = {
            vehicleId: Number(vehicleId),
            startDateRange: {
                startTimeEpoch: startDateRange.startTimeEpoch,
                endTimeEpoch: startDateRange.endTimeEpoch
            },
            expenseType: []
        }

        let defaultDateFilterValue = "ALL_MONTHS";
        let defaultTripBookFilterValue = "All Trips & Expenses";
        let defaultExpenseTypeFilter = "All Expense";


        dispatchGetMaintenanceBook(maintenanceData, defaultExpenseTypeFilter,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Maintenance Book Dweb", "Get maintenance book successfull");
                    dispatchFetchUpcoming(maintenanceData,
                        (data) => {
                            if (data && data.status && data.status.code == 200) {
                                logger.log("Maintenance Book Dweb", "Fetch maintenance upcoming successfull");
                                dispatchGetPandL(PandLdata, defaultDateFilterValue,
                                    (data) => {
                                        if (data && data.status && data.status.code == 200) {
                                            logger.log("Maintenance Book Dweb", "Get P and L report Successfull");
                                            dispatchGetTripExpenses(expenseData, defaultTripBookFilterValue,
                                                (data) => {
                                                    if (data && data.status && data.status.code == 200) {
                                                        logger.log("Maintenance Book Dweb", "Get Trip Expenses report Successfull");
                                                        setDateFilterValue("ALL_MONTHS");
                                                        setExpenseFilterValue("All_Expense");
                                                    }
                                                },
                                                () => {
                                                    logger.log("Maintenance Book Dweb", "Get Trip Expenses report Failed");
                                                },
                                            )
                                        }
                                    },
                                    () => {
                                        logger.log("Maintenance Book Dweb", "Get P and L report Failed");
                                    },
                                )
                            }
                        },
                        () => {
                            logger.log("Maintenance Book Dweb", "Fetch maintenance upcoming failed");
                        }
                    );
                }
            },
            () => {
                logger.log("Maintenance Book Dweb", "Get maintenance book failed")
            }
        );
    }



    const handleExpenseTypeFilter = (value) => {
        setExpenseFilterValue(value);
        setChangeFlag(true);
    }

    const handleMarkPaidDialog = (upcoming) => {
        setUpcomingValue(upcoming);

        dispatchGetSingleTruck(vehicleId,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Maintenance Book Dweb", "Get Single Truck Data Successfull ");
                    dispatchGetMaintenanceConfig(
                        (data) => {
                            if (data && data.status && data.status.code == 200) {
                                setMarkPaidDialogOpen(true);
                            }
                        },
                        () => {

                        }
                    );
                }
            },
            () => {
                logger.log("Maintenance Book Dweb", "Get Single Truck Data Failed");
            }
        );
    }

    const handleMarkPaidDialogClose = () => {
        setMarkPaidDialogOpen(false);
    }

    const handleMarkPaidDialogConfirm = () => {
        recall();

        setMarkPaidDialogOpen(false);
    }

    const handleCustomFilterClose = () => {
        setCustomFilter(false);
    }

    const handleCustomFilterConfirm = (value) => {
        setDateFilterValue("CUSTOM");
        setCustomFilter(false);
        setCustomFilterValue(value);
    }

    return (
        <>
            {onOpen && <RightSideBar
                sideBarName="maintenance-book"
                rightSideBarOpen={onOpen}
                sideBarTitle={'Maintenance Book'}
                sideBarType="truckBook"
                vehicleNumberValue={vehicleNumberType}
                truckType={maintenanceBookDetails && maintenanceBookDetails.vehicleBodyType ? maintenanceBookDetails.vehicleBodyType : ""}
                handleSubmit={event => submit(event)}
                addExpense={handleAddMaintenanceExpense}
                toggleRightSideBar={onConfirm} >

                {maintenanceBookDetails.totalCount == 0 &&
                    <>
                        <div className={classes.divEmptyState}>
                            <MaintenanceIcon className={classes.maintenanceBookIcon} />
                            <div className={classes.emptyState}> Add your Maintenance expenses to get <div>Monthly vehicle Profit</div></div>
                        </div>
                    </>
                }

                {maintenanceBookDetails.totalCount > 0 &&
                    <>
                        <div className={classes.divFilter}>
                            <div>
                                <div className={classes.dateRange}>Date Range</div>
                                <DateFilter dateValue={handleDateValue} fromSingleVehicle={true} defaultValue={dateFilterValue} />
                            </div>
                            <div className={classes.mlV2}>
                                <div className={classes.dateRange}>Expense Type</div>
                                <ExpenseTypeFilter fromMaintenanceBook={true} filterValue={handleExpenseTypeFilter} />
                            </div>
                        </div>

                        <div className={classes.marginV1}>
                            <Card className={classes.brV1}>
                                <CardContent className={classes.cardContentV1}>
                                    <div>
                                        <div className={classes.titleV1}>Total Cost</div>
                                        <div className={classes.totalRevenue}>{maintenanceBookDetails && (maintenanceBookDetails.totalCost || maintenanceBookDetails.totalCost == 0) ? numberFormat(maintenanceBookDetails.totalCost) : maintenanceBookDetails.totalCost}</div>
                                    </div>
                                </CardContent>
                            </Card>
                        </div>

                        {maintenanceUpcoming && maintenanceUpcoming.length > 0 &&
                            <div>
                                <div className={classes.divUpcomingHeader}>UPCOMING</div>

                                {maintenanceUpcoming.map((upcoming) => (
                                    <Card className={classes.marginV1}>
                                        <CardContent className={classes.cardContentV3}>
                                            <div className={classes.displayFlex}>
                                                <div className={classes.divV3}>
                                                    <div className={classes.divExpenseName}>
                                                        {upcoming.expenseName}
                                                    </div>
                                                    <div className={classes.divV4}>
                                                        <div className={classes.divDue}>
                                                            DUE
                                                        </div>
                                                        <div className={classes.divDate}>
                                                            {getDateInStringDocumentDDMMMYYYY(upcoming.text)}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={classes.divV5}>
                                                    <Button variant="outlined" className={classes.buttonV1} onClick={() => handleMarkPaidDialog(upcoming)}>
                                                        <DoneIcon className={classes.doneIconV1} />
                                                        <span className={classes.divMarkDone}>Mark Done</span>
                                                    </Button>
                                                </div>
                                            </div>
                                        </CardContent>
                                    </Card>
                                ))
                                }
                            </div>
                        }

                        <div className={classes.marginV2}>
                            {
                                (maintenanceBookDetails && maintenanceBookDetails.maintenanceItems) &&
                                <>
                                    <div className={classes.mbV1}>
                                        {
                                            maintenanceBookDetails.maintenanceItems.map((maintenance) => (
                                                <>

                                                    < div className={classes.divMonth}>
                                                        {maintenance.month}
                                                    </div>
                                                    {
                                                        maintenance.lineItems.map((items) => (

                                                            <>
                                                                < div className={classes.mtV2}>
                                                                    <Card className={classes.brV1}>
                                                                        <CardContent className={classes.cardContentV4}>
                                                                            <div>
                                                                                <div className={classes.divV6}>
                                                                                    <div className={classes.fsV1}>
                                                                                        {items.expenseName &&
                                                                                            <>
                                                                                                <div>{items.expenseName}</div>
                                                                                            </>
                                                                                        }
                                                                                    </div>

                                                                                    <div className={classes.displayFlex}>
                                                                                        <div>
                                                                                            <IconButton className={classes.pV1} onClick={() => handleEditExpense(items.id)}><EditIcon className={classes.editIcon} /></IconButton>
                                                                                        </div>
                                                                                        <div className={classes.mlV1}>
                                                                                            <IconButton className={classes.pV1} onClick={() => handleDeleteExpense(items.id)}><DeleteIcon className={classes.deleteIcon} /></IconButton>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                {items.tripId &&
                                                                                    <div className={classes.divFromATrip}>
                                                                                        <div className={classes.fromATrip}>From a trip</div>
                                                                                    </div>
                                                                                }
                                                                                <div className={classes.divV2}>
                                                                                    <div>
                                                                                        <span>{getDateStringDDMMM(items.expenseDate)}</span>
                                                                                        {items.kmReading &&
                                                                                            <>
                                                                                                <span className={classes.bullet}>•</span>
                                                                                                <span>{numberFormatComma(items.kmReading)} Kms</span>
                                                                                            </>
                                                                                        }
                                                                                    </div>
                                                                                    <div className={classes.divAmount}>
                                                                                        {numberFormat(items.amount)}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </CardContent>
                                                                    </Card>
                                                                </div>
                                                            </>
                                                        ))
                                                    }
                                                </>


                                            ))
                                        }
                                    </div>
                                </>
                            }
                        </div>

                    </>
                }

            </RightSideBar>
            }
            {markPaidDialogOpen && <MarkDoneDialog upcomingData={upcomingValue} open={markPaidDialogOpen} onClose={handleMarkPaidDialogClose} onConfirm={handleMarkPaidDialogConfirm} />}
            {addMaintenanceExpenseDialogOpen && <AddMaintainanceExpenseDialog open={addMaintenanceExpenseDialogOpen} onClose={handleAddMaintenanceExpenseClose} onConfirm={handleExpenseConfirm} maintenanceExpenseData={singleExpenseDetails} edit={editExpenseDialog} expenseId={expenseIdValue} />}
            {deleteExpenseDialogOpen && <DeleteExpenseDialog open={deleteExpenseDialogOpen} onClose={handleDeleteClose} onConfirm={handleDeleteExpenseConfirm} expenseParentType={"maintenance"} expenseId={expenseIdValue} />}
            {customFilter && <CustomDateFilterDialog open={customFilter} onClose={handleCustomFilterClose} onConfirm={handleCustomFilterConfirm} />}

        </>
    )

}

const mapStateToProps = (state) => ({ vehicle: state.vehicle });
const mapDispatchToProps = (dispatch) => ({
    dispatchGetMaintenanceBook: (data, defaultExpenseTypeFilter, onSuccess, onFailure) => {
        dispatch(fetchMaintenanceBook(data, defaultExpenseTypeFilter, onSuccess, onFailure))
    },
    dispatchFetchUpcoming: (data, onSuccess, onFailure) => dispatch(fetchMaintenanceUpcoming(data, onSuccess, onFailure)),
    dispatchGetPandL: (data, defaultDateFilterValue, onSuccess, onFailure) => dispatch(PandL(data, defaultDateFilterValue, onSuccess, onFailure)),
    dispatchGetTripExpenses: (data, defaultTripBookFilterValue, onSuccess, onFailure) => dispatch(Expenses(data, defaultTripBookFilterValue, onSuccess, onFailure)),
    dispatchFetchSingleExpense: (expenseId, onSuccess, onFailure) => dispatch(FetchExpenseDetails(expenseId, onSuccess, onFailure)),
    dispatchGetSingleTruck: (truckId, onSuccess, onFailure) => dispatch(singleTruck(truckId, onSuccess, onFailure)),
    dispatchGetMaintenanceConfig: (onSuccess, onFailure) => dispatch(getVehicleMaintenanceConfig(onSuccess, onFailure)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MaintenanceBook);